import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles/app.css';

/**
 * StrictMode stays ON, and that is a test rather than a formality: it double-invokes
 * every effect in development, which means the session provider's boot effect fires
 * twice on every reload. Under a naive refresh interceptor that is enough to present
 * a rotated refresh token and trip Phase 0's revoke-on-rotate theft detection —
 * logging the developer out on page load. The single-flight mutex in `lib/api.ts`
 * (D-web-1) is what makes it a non-event, so running with StrictMode enabled keeps
 * that guarantee under continuous pressure instead of only in a unit test.
 */
const container = document.getElementById('root');
if (container === null) {
  throw new Error('index.html is missing its #root element.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
